import { DeviceOperationalState } from '@/__generated__/graphql';
import DeviceNameSpan from '@components/deviceNameSpan';
import ModalActions from '@components/modal/ModalActions';
import ModalContent from '@components/modal/ModalContent';
import ModalTitle from '@components/modal/ModalTitle';
import { useUpdateOperationalStateMutation } from '@features/changeOperationalState/hooks/useUpdateOperationalStateMutation';
import { t, Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { Dialog } from '@mui/material';
import { FC } from 'react';

interface Props {
  open: boolean;
  onClose: () => void;
  deviceId: string | null;
}

export const RestoreDeviceModal: FC<Props> = ({ deviceId, open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      {deviceId && <SuspenseComponent deviceId={deviceId} onClose={onClose} />}
    </Dialog>
  );
};

const SuspenseComponent: FC<{ deviceId: string; onClose: () => void }> = ({
  deviceId,
  onClose,
}) => {
  const { i18n } = useLingui();
  const { updateOperationalState, loading } = useUpdateOperationalStateMutation(deviceId, {
    onCompleted: () => {
      onClose();
    },
  });

  const restoreDevice = () => {
    updateOperationalState(DeviceOperationalState.Active);
  };

  return (
    <>
      <ModalTitle
        title={
          <Trans>
            Desarchivar dispositivo <DeviceNameSpan deviceId={deviceId} />
          </Trans>
        }
      />
      <ModalContent>
        <Trans>¿Estás seguro que deseas desarchivar el dispositivo?</Trans>
      </ModalContent>
      <ModalActions
        onClose={onClose}
        submitButton={{
          label: t(i18n)`Desarchivar`,
          onClick: restoreDevice,
          loading,
        }}
      />
    </>
  );
};
